module.exports = __webpack_public_path__ + "img/shangye_yicuiyuan_suoluetu.361d91af.png";